// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".form-group[data-v-578102d4] {\n  gap: 2rem;\n  display: flex;\n  margin-left: 2rem;\n  align-items: center;\n  justify-content: flex-start;\n}\n.form-group label[data-v-578102d4] {\n  width: 130px;\n  color: #777;\n  margin-bottom: 0px;\n}\n.form-group input[data-v-578102d4] {\n  max-width: 260px;\n}\n.form-group p[data-v-578102d4] {\n  color: #777;\n  margin-bottom: 0px;\n}", ""]);
// Exports
module.exports = exports;
